module.exports = __webpack_public_path__ + "static/media/slider-4.4d7af2fa.jpg";